import { createFileRoute } from '@tanstack/react-router'
import { serialSearchSchema } from '../../../features/inventory/serials/search'
import { SerialsPage } from '../../../features/inventory/serials/serial-pages'

export const Route = createFileRoute('/_app/serials/')({
  validateSearch: serialSearchSchema,
  component: SerialsPage,
})
